import { Component, Input } from '@angular/core';

import { InputBaseComponent } from '../input.base';

@Component({
  selector: 'app-input-textarea',
  templateUrl: './input-textarea.component.html',
  styleUrls: ['./../input.base.scss', './input-textarea.component.scss']
})
export class InputTextareaComponent extends InputBaseComponent {
  @Input() public rows = 15;
  @Input() public maxLength: number | null = null;

  public get valueLength(): number {
    return `${this.inputControl?.value ?? ''}`.length;
  }
}
